import { IControlInput, IDeviceCategory, IDeviceInformation, IDeviceItemGrouping, IDeviceNode } from './device';

// The root of the device information that is loaded and updated
// via the device service.
export class DeviceInformation implements IDeviceInformation {
    // The underlying device node hierarchy.  This should
    // only be accessed via the service.  All controllers
    // should interface with public typed properties.
    public $deviceHierarchy: IDeviceNode;

    public $ignoreChildren: boolean;
    public $categories: IDeviceCategory[];
    public $sections: IDeviceItemGrouping[];
    public $controlInputs: IControlInput[];
    public elementType: string;

    constructor(
        state: IDeviceNode
    ) {
        this.$ignoreChildren = false;
        this.$deviceHierarchy = state;

        this.elementType = state.elementType;
        this.$categories = [];
        this.$sections = [];
        this.$controlInputs = [];
    }
}
